<div class="text-center w-100 d-flex flex-column align-items-center justify-content-center">
  <img src="../../../assets/img/coming-soon.png" class="mb-4" />

  <h3 class="mb-4">{{ "This Service is Coming Soon" | translate }}</h3>

  <button class="gradient-button" routerLink="">
    {{ "Go Back To Home Page" | translate }}
  </button>
</div>
